import { useTranslation } from "react-i18next"
import { useHistory } from "react-router"
import { useToitEnPente } from "../../../store/toit-en-pente/hooks"
// import { renderer } from "../../viewer/Renderer"
import { useRoutes } from "../../../store/routes/hooks"
import {
  ToitEnPenteAcousticLayerTypes,
  ToitEnPenteClimateTypes,
  ToitEnPenteStructureTypes,
} from "@iko-design-center/shared"
import { useEffect } from "react"
import { renderer } from "../../viewer/Renderer"

export function useToitRainCover() {
  const { Routes } = useRoutes() as any
  const { t } = useTranslation() as any
  const history = useHistory()

  const {
    configurationState,
    setToitRainCoverType: setToitRainCoverTypeState,
    setToitAcousticLayerType: setToitAcousticLayerTypeState,
  } = useToitEnPente()

  const toitInsulation = configurationState.toitInsulation
  const toitClimateType = configurationState.toitClimate.type
  const toitStructureType = configurationState.toitStructure.type
  const toitRainCoverType = configurationState.toitRainCover.type
  const nextButtonDisabled = !toitRainCoverType

  useEffect(() => {
    if (toitClimateType !== ToitEnPenteClimateTypes.PLAIN_CLIMATE) {
      history.push(Routes.TOIT_EN_PENTE_1_STRUCTURE)
    }
  }, [toitClimateType, history, Routes])

  useEffect(() => {
    renderer.displayToitEnPenteStructureType(toitStructureType)
  }, [toitStructureType])

  function handleNextButtonClick() {
    history.push(Routes.TOIT_EN_PENTE_3_OVERVIEW)
  }

  function setToitRainCoverType(type: any) {
    setToitRainCoverTypeState(type)
    renderer.displayToitEnPenteRainCoverType(type)

    const insulationMaterial = toitInsulation.material
    if (insulationMaterial && insulationMaterial.thickness) {
      switch (toitStructureType) {
        case ToitEnPenteStructureTypes.ON_WOOD_RAFTERS:
          if (insulationMaterial.thickness <= 132) {
            setToitAcousticLayerTypeState(ToitEnPenteAcousticLayerTypes.DB_38)
          } else {
            setToitAcousticLayerTypeState(ToitEnPenteAcousticLayerTypes.DB_40)
          }
          break
        case ToitEnPenteStructureTypes.ON_WOOD_BOARDS:
          if (insulationMaterial.thickness <= 132) {
            setToitAcousticLayerTypeState(ToitEnPenteAcousticLayerTypes.DB_43)
          } else {
            setToitAcousticLayerTypeState(ToitEnPenteAcousticLayerTypes.DB_44)
          }
          break
      }
    }
  }

  return {
    t,
    toitStructureType,
    toitRainCoverType,
    setToitRainCoverType,
    handleNextButtonClick,
    nextButtonDisabled,
  }
}
